import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./checkoutPaymentSuccessPageComponent.scss";
import orderActions from "../../../store/actions/orders/order.actions";
import { useDispatch } from "react-redux";

const CheckoutPaymentSuccessPageComponent = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getQueryParams();
  }, []);

  const getQueryParams = async () => {
    const queryParams = new URLSearchParams(location.search);

    // Extracting relevant parameters
    const OGCustomerID = queryParams.get("OG-CustomerID");
    const OGPaymentID = queryParams.get("OG-PaymentID");
    const OGPaymentType = queryParams.get("OG-PaymentType");
    const OGExternalIdentifier = queryParams.get("OG-ExternalIdentifier");
    const OGDocumentNumber = queryParams.get("OG-DocumentNumber");

    if (!OGCustomerID || !OGPaymentID || !OGExternalIdentifier || !OGDocumentNumber) {
      return; // Prevent unnecessary requests if parameters are missing
    }

    const request = {
      OGCustomerID: Number(OGCustomerID),
      OGPaymentID: Number(OGPaymentID),
      OGPaymentType,
      OGExternalIdentifier,
      OGDocumentNumber: Number(OGDocumentNumber),
    };
    // Remove search parameters from URL
    navigation(location.pathname, { replace: true });
    const createPaymentPageResponse = await dispatch(orderActions.updateOrderPaymentSuccess(request));
    // Automatically navigate to home page after a delay
    setTimeout(() => {
      navigation("/");
    }, 5000);
  };

  return (
    <div className="success-payment-page-container">
      <h1 className="heading1">תודה על ההזמנה שלך!</h1>
      <h2>התשלום בוצע בהצלחה!</h2>
      <span>תוכל לצפות בקבלה עבור הרכישה בכתובת הדואר האלקטרוני אותה הזנת ברגע ההזמנה</span>

      <button className="primaryButton" onClick={() => navigation("/")}>
        חזרה לעמוד הראשי
      </button>
    </div>
  );
};

export default CheckoutPaymentSuccessPageComponent;
